import React from "react";
import TemplateDocumentItem from "./TemplateDocumentItem";

const TemplateDocumentsList = () => {
  return (
    <div className="template-documents">
      <TemplateDocumentItem
        documentType={0}
        title="Expenses Form"
        downloadName="Expenses Form"
        fileExtension="xltx"
      />
      <TemplateDocumentItem
        documentType={2}
        title="Incident Report Form"
        downloadName="Incident Report Form"
        fileExtension="docx"
      />
      <TemplateDocumentItem
        documentType={1}
        title="Weekly Report Form"
        downloadName="Weekly Report Form"
        fileExtension="docx"
      />
    </div>
  );
};

export default TemplateDocumentsList;
